import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'main-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  isMenuOpen: boolean = false;
  currentPageUrl = this.router.url;
  currentRoute: string = '';
  isLoggedIn = false;
  isManageActive = false;
  isHome = false;
  constructor(private router: Router, private userService : UserService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url.split('?')[0]; // removes query params
      }
    });
  }
  ngOnInit(): void {
  this.isLoggedIn = !!localStorage.getItem('0');
  this.updateActiveFlags(this.router.url);
  this.router.events
    .pipe(filter(e => e instanceof NavigationEnd))
    .subscribe((e: NavigationEnd) => this.updateActiveFlags(e.urlAfterRedirects));
}
  scrollToPlans(){
    if (this.currentPageUrl !== '/') {
      this.router.navigateByUrl('/').then(() => {
        window.scroll({ 
          top: 3020, 
          left: 0, 
          behavior: 'smooth' 
        });
      }).catch(error => {
        console.error('Navigation error:', error);
      });
    } else {
      window.scroll({ 
        top: 3020, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  }
  scrollToPlansAndDownloadsMobile(){

    if (this.currentPageUrl !== '/') {

      this.router.navigateByUrl('/').then(() => {
        const target = document.getElementById('mobile-only');
        target?.scrollIntoView({ behavior: 'smooth' });
        // window.scroll({ 
        //   top: 4400, 
        //   left: 0, 
        //   behavior: 'smooth' 
        // });
      }).catch(error => {
        console.error('Navigation error:', error);
      });
    } else {
      const target = document.getElementById('mobile-only');
      target?.scrollIntoView({ behavior: 'smooth' });
      // window.scroll({ 
      //   top: 4400, 
      //   left: 0, 
      //   behavior: 'smooth' 
      // });
    }
  }
    private updateIsHome(url: string) {
    const path = url.split('?')[0].split('#')[0];
    this.isHome = path === '/' || path === '/home'; // treat /home as home too
  }

  scrollToContacts(){
  
    if (this.currentPageUrl !== '/') {
      this.router.navigateByUrl('/').then(() => {
        window.scroll({ 
          top: 8000, 
          left: 0, 
          behavior: 'smooth' 
        });
      }).catch(error => {
        console.error('Navigation error:', error);
      });
    } else {
      window.scroll({ 
        top: 8000, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  }
  scrollToDiv(divId: string): void {
    const element = document.getElementById(divId);
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.error(`Element with ID '${divId}' not found.`);
    }
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
    logout(): void {
    this.userService.logout();
    this.isLoggedIn = false;
  }
  private updateActiveFlags(url: string) {
  const path = url.split('?')[0].split('#')[0];
  this.isHome = path === '/' || path === '/home';
  this.isManageActive = path === '/login' || path === '/dashboard';
}
}
